import {ActionLocal} from "./actions.service";
import {type} from "../../common/utils";

export class ApplicationContextActions {

  static ActionType = {
    SET_CONTEXT: type('[ApplicationContextActions] SET_CONTEXT'),
    SET_SPECS_FROM_CONTEXT: type('[ApplicationContextActions] SET_SPECS_FROM_CONTEXT'),
    FRAME_MODE: type("[ApplicationContextActions] FRAME_MODE"),
  };

  public static setContext(context: any): ActionLocal {

    return {
      type: ApplicationContextActions.ActionType.SET_CONTEXT,
      payload: context
    };
  }

  public static setSpecsFromContext(): ActionLocal {
    return {type: ApplicationContextActions.ActionType.SET_SPECS_FROM_CONTEXT};
  }

  public static setFrameMode(inFrame: boolean): ActionLocal {
    return { type: ApplicationContextActions.ActionType.FRAME_MODE, payload: inFrame};
  }
}
